import { SVG } from '@svgdotjs/svg.js';

export function syncBrandBackground(conf, form, template, route) {
  const backgroundColor = conf.backgroundColors?.[0];
  const backgroundColorEnabled = backgroundColor && (
    form.backgroundColorsStatus?.[backgroundColor.id] ?? Boolean(backgroundColor.enabled)
  );
  const backgroundImage = SVG('#backgroundImage');

  if (backgroundColorEnabled) {
    SVG(`#${backgroundColor.id}`)?.removeClass('hidden');
    backgroundImage?.addClass('hidden');
    return;
  }

  if (backgroundColor) {
    SVG(`#${backgroundColor.id}`)?.addClass('hidden');
  }

  if (form.backgroundImage && form.backgroundImageStatus) {
    backgroundImage?.attr('href', form.backgroundImage);
    backgroundImage?.removeClass('hidden');
    return;
  }

  // Config order is deliberate: the first active brand has priority (GX for template 49).
  const brandBackground = (conf.brandBackgrounds || []).find(({ extraId }) => {
    const extra = (conf.extras || []).find(({ id }) => id === extraId);

    return form.extraColorStatus?.[extraId] ?? Boolean(extra?.enabled);
  });

  if (!brandBackground) {
    backgroundImage?.addClass('hidden');
    return;
  }

  backgroundImage?.attr(
    'href',
    route('social-graphics.brand-background.link', {
      template,
      image: brandBackground.image,
    })
  );
  backgroundImage?.removeClass('hidden');
}
